import { Box, Modal, Typography } from "@mui/material";
import ButtonComponent from "../Inputs/ButtonComponent";
import "../../CSS/ComponentCSS/PublicModal.css";

type PublicModalProps = {
  open: boolean;
  onClose: (value: boolean) => void;
  message: string;
  cancel?: boolean;
};
export default function PublicModal(props: PublicModalProps) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className="PublicModalBox">
        <Typography variant="h6" component="h2">
          {props.message}
        </Typography>
        <div className="publicModalBottom">
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={() => props.onClose(true)}
            className="publicModalUpdateButton"
          >
            확인
          </ButtonComponent>
          {props.cancel && (
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(false)}
              className="publicModalButton"
            >
              취소
            </ButtonComponent>
          )}
        </div>
      </Box>
    </Modal>
  );
}
